import { render, staticRenderFns } from "./ElectronicContractDetail.vue?vue&type=template&id=53201efe&scoped=true"
import script from "./ElectronicContractDetail.vue?vue&type=script&lang=js"
export * from "./ElectronicContractDetail.vue?vue&type=script&lang=js"
import style0 from "./ElectronicContractDetail.vue?vue&type=style&index=0&id=53201efe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53201efe",
  null
  
)

export default component.exports